<template>
    <div>
        <div class="spacer-10"></div>
        <div class="part-line"></div>
        <div class="main-title">Withdrawal XRP</div>
        <div class="pd-box2">
            <div class="pd-input-zone">
                <div class="pd-box-comment" >
                    1. When entering the wallet address to deposit, if you enter the wrong wallet address and destination tag, the withdrawal will not proceed<br/>
                    2. If there is a blank in front and back of the wallet address, withdrawal will not be processed.
                </div>
            </div>
            <div class="pd-input-zone">
                <div class="pd-input-zone-left">
                    <p>Withdrawable XRP</p>
                    <input type="text" name="withdrawable" id="withdrawable" class="form-control input-readonly" v-model="withdrawable" readonly>
                </div>
                <div class="pd-input-zone-right">
                    <p>Withdrawal Request XRP(Min:50 XRP)</p>
                    <input type="number" name="withdrawal" id="withdrawal" class="form-control" pattern="[0-9]+" min="0" v-model="withdrawal"
                           oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                           @input="withdrawalChangeFunc($event)">
                </div>
            </div>
            <div class="pd-input-zone">
                <div class="spacer-30 mb-mode"></div>
                <div class="pd-input-zone-left">
                    <p>Withdrawal XRP</p>
                    <input type="text" name="transfer_xrp" id="transfer_xrp" class="form-control input-readonly" v-model="transfer_xrp" readonly>
                </div>
                <div class="pd-input-zone-right">
                    <p>Withdrawal Fee XRP</p>
                    <input type="text" name="transfer_fee" id="transfer_fee" class="form-control input-readonly" v-model="transfer_fee" readonly>
                </div>
            </div>
            <div class="pd-input-zone">
                <div class="spacer-30 mb-mode"></div>
                <div class="pd-input-zone-left">
                    <p>Reinvestment XRP</p>
                    <input type="text" name="reinvestment_xrp" id="reinvestment_xrp" class="form-control input-readonly" v-model="reinvestment_xrp" readonly>
                </div>
            </div>
            <div class="pd-input-zone">
                <div class="pd-input-zone-w">
                    <p>Your XRP Wallet Address</p>
                    <input type="text" name="wallet_address" id="wallet_address" class="form-control" v-model="wallet_address">

                    <div class="spacer-40 pc-mode"></div>
                    <div class="spacer-30 mb-mode"></div>

                    <p>Destination Tag (Optional)</p>
                    <input type="text" name="destination_tag" id="destination_tag" class="form-control" v-model="destination_tag">
                </div>
            </div>
            <div class="pd-box-txt">
                When sending a remittance to an address that exists on the exchange, you must<br/>
                enter the Destination Tag to complete the normal deposit to the user's account.
            </div>
            <div class="m-btn" v-if="showWithdrawButton">
                <!-- 출금처리중에는 spinner가 보이고 버튼 클릭이 동작하지 않는다..-->
                <button v-on:click="confirmWithdraw" :disabled="isLoading === true">
                    <b-spinner small type="grow" v-if="isLoading"></b-spinner> Submit
                </button>
                <!-- <a> 를 사용하면 모달을 띄울때 창상단으로 스크롤 되어 버린다. 따라서 button을 사용한다.-->
                <!--<a href="#" v-on:click="withdraw" >Submit</a>-->
            </div>
        </div>
        <!-- Modals -->
        <div class="row">
            <modal :show.sync="modals.notificationShow"
                   gradient="danger"
                   modal-classes="modal-warning modal-dialog-centered modal-title-notification">
                <h6 slot="header" class="modal-title" id="modal-title-notification">Your attention is required</h6>

                <div class="py-3 text-center">
                    <img src="/img/common/withdraw.png"/>
                    <h4 class="heading mt-4">{{ notificationMessage }}</h4>
                </div>

                <template slot="footer">
                    <!--<base-button type="white">Ok, Got it</base-button>-->
                    <base-button type="link"
                                 text-color="white"
                                 class="ml-auto"
                                 @click="modals.notificationShow = false">
                        Close
                    </base-button>
                </template>
            </modal>
            <modal :show.sync="modals.info"
                   modal-classes="modal-info modal-dialog-centered modal-title-notification">
                <h6 slot="header" class="modal-title" id="modal-title-confirmation">Success!</h6>
                <p>
                    {{ infoMessage }}
                </p>
                <template v-slot:footer>
                    <base-button
                            type="link"
                            text-color="white"
                            class="ml-auto"
                            @click="modals.info = false"
                    >Close</base-button>
                </template>
            </modal>
            <modal :show.sync="modals.confirmationShow"
                   modal-classes="modal-info modal-dialog-centered modal-title-notification">
                <h6 slot="header" class="modal-title" id="modal-title-confirmation">Your confirmation is required</h6>

                <div class="py-3 text-center">
                    <img src="/img/common/withdraw.png"/>
                    <h4 class="heading mt-4">{{ confirmationMessage }}</h4>
                </div>

                <template slot="footer">
                    <base-button type="white" class="modal-confirm-btn"
                                 v-on:click="withdraw">Ok, Got it</base-button>
                    <base-button type="link"
                                 text-color="white"
                                 class="ml-auto"
                                 @click="modals.confirmationShow = false">
                        Close
                    </base-button>
                </template>
            </modal>
        </div>
    </div>
</template>
<style>
    .modal-info > .modal-content {
        border: 0px !important;
        background-color: #6097e6 !important;
    }
    .modal-warning > .modal-content {
        border: 0px !important;
    }
    .pd-box-comment {
        text-align: left;
        color: #fff;
        font-size: 18px;
        padding: 0px 40px !important;
    }
</style>
<script>
import {mapGetters} from "vuex";
import axios from "../../service/axios";
import Modal from "@/components/Modal.vue";
export default {
    components: {
        Modal
    },
    data: () =>{
        return {
            isLoading: false,
            showWithdrawButton: true,
            modals: {
                info: false,
                notificationShow: false,
                confirmationShow: false,
            },
            confirmationMessage : '',
            notificationMessage : '',
            infoMessage: '',
            infoSubMessage: '',
            withdrawal : '0', // 인출하고자 하는 금액
            transfer_xrp : '0', // 실제인출되는 금액 (withdrawal의 50%)
            reinvestment_xrp : '0', // 재투자되는 금액 (withdrawal의 50%)
            transfer_fee : '0', // 수수료..
            wallet_address:'',
            destination_tag:''
        }
    },
    created() {

    },
    computed: {
        ...mapGetters(["isAuthenticated"]),
        ...mapGetters(["detail"]),  /* store에 저장된 값을 가져온다. */
        ...mapGetters(["user"]),
        withdrawable: {
            get : function() {
                if (this.isAuthenticated) {
                    return this.detail.total_balance ; // 인출가능금액
                } else {
                    return "0";
                }
            }
        },
        withdrawFeeRate: {
            get : function() {
                if (this.isAuthenticated) {
                    return this.detail.withdraw_fee_rate ; // 출금 수수료 0.05
                } else {
                    return "0";
                }
            }
        },
        withdrawMinAmount: {
            get : function() {
                if (this.isAuthenticated) {
                    return this.detail.withdraw_min_amount ; // 출금시 최소 금액
                } else {
                    return "0";
                }
            }
        },
        withdrawRate: {
            get : function() {
                if (this.isAuthenticated) {
                    return this.detail.withdraw_rate ; // 실인출가능금액비율
                } else {
                    return "0";
                }
            }
        },
        reinvestRate: {
            get : function() {
                if (this.isAuthenticated) {
                    return this.detail.reinvest_rate ; // 재투자비율
                } else {
                    return "0";
                }
            }
        },
    },
    mounted() {
        //console.log("withdrawal - mounted");
    },
    methods: {
        getSafeFloat : function(value) {
            let strVal = value + '';
            strVal = strVal.replace(/,/g, '');
            return Number.parseFloat(strVal);
        },
        withdrawalChangeFunc(event){
            if (!this.isAuthenticated) {
                return;
            }
            this.transfer_fee = (this.withdrawal * this.withdrawRate * 0.01) * 0.03; // 실제 송금하는 금액(재투자제외)의 3%를 수수료로 한다.
            /*const remainder = this.withdrawable - this.withdrawal - this.transfer_fee;
            if (remainder < 0) {
                return false;
            }*/
            this.transfer_xrp = (this.withdrawal * this.withdrawRate * 0.01 ) - this.transfer_fee;
            this.reinvestment_xrp = this.withdrawal * this.reinvestRate * 0.01;
        },
        confirmWithdraw:function() {
            if (!this.isAuthenticated) {
                this.notificationMessage = "You are not logged in. Please log in and try again";
                this.modals.notificationShow = true;
                return ;
            }

            if (parseInt(this.withdrawal) < parseInt(this.withdrawMinAmount)) {
                this.notificationMessage = "The withdrawal amount must be at least " + this.withdrawMinAmount + " XRP.";
                this.modals.notificationShow = true;
                return;
            }

            this.transfer_fee = (this.withdrawal * this.withdrawRate * 0.01) * this.withdrawFeeRate; // 실제 송금하는 금액(재투자제외)의 5%를 수수료로 한다.
            const remainder = this.getSafeFloat(this.withdrawable) - this.withdrawal;
            console.log("remainder = " + remainder);
            if (remainder < 0) {
                this.notificationMessage = "The withdrawal amount has exceeded.";
                this.modals.notificationShow = true;
                return false;
            }
            if (!this.wallet_address) {
                this.notificationMessage = "Please, Enter your wallet address.";
                this.modals.notificationShow = true;
                return false;
            }

            this.confirmationMessage = 'Will you proceed the withdraw xrp';
            this.modals.confirmationShow = true;

            /*if (!this.destination_tag) {
                this.notificationMessage = "Please, your wallet destination_tag.";
                this.modals.notificationShow = true;
                return false;
            }*/
        },
        withdraw:function(){
            this.modals.confirmationShow = false;
            this.isLoading = true;
            const data = {
                withdrawal : this.withdrawal,
                wallet_address: this.wallet_address,
                destination_tag: this.destination_tag,
            };
            if (this.isAuthenticated) {
                // JWT-Token Expired check
                axios
                    .post("/auth/v1/verifyToken")
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error)
                    });
                axios
                    .post("/xrp/v1/withdraw", data)
                    .then(response => {
                        if (response.status === 200) {
                            //console.log(response.data)
                            if (response.data.status === 'f') {
                                this.notificationMessage = response.data.message;
                                this.modals.notificationShow = true;
                            } else {
                                // 투자성공했으니, 인출정보는 지워주자.
                                this.wallet_address = '';
                                this.destination_tag = '';
                                this.withdrawal = 0;
                                this.transfer_xrp = 0;
                                this.reinvestment_xrp = 0;
                                this.transfer_fee = 0;
                                this.infoMessage = 'The withdrawal request was successful.';
                                this.modals.info = true;

                                this.$store.dispatch("setDetail");
                            }
                        }
                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log(error)
                        this.isLoading = false;
                    });
            }
        }
    }
};
</script>
<style>
</style>
